import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs/internal/observable/of';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { ToastrService } from '../../../../shared/services/utilities/toastr.service';
import {
  HydraCollection,
  ProfessionalJob,
  ProfessionalJobService,
  WebServiceOptions,
  WebServiceSubResourceFetchMode,
} from '@adeo/ngx-kozikaza-api';
import { HttpParams } from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';
import { ProNavigationService } from '../pro-navigation.service';
import { jobSlug as jobSlugName } from '../professional-routing.module';

@Injectable()
export class JobNavigationGuard  {

  constructor(
    private professionalJobService: ProfessionalJobService,
    private toastrService: ToastrService,
    private router: Router,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly proNavigationService: ProNavigationService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const jobSlug = route.paramMap.get(jobSlugName);
    const webServiceOptions: WebServiceOptions = {
      subResourceFetchMode: WebServiceSubResourceFetchMode.SYNC,
      refresh: false,
      query: new HttpParams({fromObject: {
          nameSlug: `${jobSlug}`
        }
      })
    };
    return ((jobSlug) ? this.professionalJobService.getProfessionalJobs(null, webServiceOptions).pipe(
      catchError((err: any) => {
        if (err.status === 404) {
          this.toastrService.error($localize`:@@toast.could_not_retrieve_pro_job:Unable to retrieve professional job`);
          this.handleNotFound(err);
        } else if (err.status === 500) {
          this.toastrService.error($localize`:@@toast.could_not_retrieve_pro_job:Unable to retrieve professional job`);
          this.router.navigate(this.localizeRouterService.translateRoute(['/error'])as string[],
            {queryParams: {from: err.url}});
        }
        return of(null);
      }),
      switchMap((collection: HydraCollection<ProfessionalJob>) => {
        if (collection['hydra:totalItems'] === 0 || collection['hydra:member'].length === 0 ) {
          this.toastrService.error($localize`:@@toast.could_not_retrieve_pro_job:Unable to retrieve professional job`);
          this.handleNotFound({url: jobSlug});
          return of(false);
        } else {
          this.proNavigationService.setJob(collection['hydra:member'][0], false);
          return of(true);
        }
      })
    ) : of(false)).pipe();
  }

  private handleNotFound(err: any) {
    this.router.navigate(this.localizeRouterService.translateRoute(['/not_found'])as string[], {queryParams: {from: err.url}});
  }
}
